<template>
    <app-main>
        <app-content>

            <div class="flex flex-wrap -mx-2">
                <div class="w-full md:w-1/2 px-2">
                    <!-- Start Title -->
                    <app-title
                        title="Services"
                        sub-title="Editing a service"
                    />
                    <!-- End Title -->
                </div>
                <div class="w-full md:w-1/2 px-2 md:text-right">
                     <app-button element="a" class="btn  btn--primary  btn--primary--sml" @click="save">
                        Save
                    </app-button>

                    <app-button
                        v-if="service"
                        element="a" class="btn  btn--secondary  btn--secondary--sml ml-4"
                        @click="$router.push({ name: 'services.home', query: { page: $route.params.page ? $route.params.page : 1, search: $route.params.search ? $route.params.search : '' } })"
                    >
                        Cancel
                    </app-button>
                </div>
            </div>

            <app-tabs-wrapper default="general" :loading="loading" :initial="loading" class="mb-8">
                <div class="w-full flex items-center border-b-2 border-grey-lighter" slot-scope="{ toggle, active }">
                    <app-tabs-trigger name="general" :handle-click="toggle" :active="active">General</app-tabs-trigger>
                    <app-tabs-trigger name="content" :handle-click="toggle" :active="active">Content</app-tabs-trigger>
                    <!-- <app-tabs-trigger name="locations" :handle-click="toggle" :active="active" v-if="!fields.autino_enabled">Locations</app-tabs-trigger> -->
                    <app-tabs-trigger name="seo" :handle-click="toggle" :active="active">SEO &amp; Search</app-tabs-trigger>
                    <!-- <app-tabs-trigger name="bundle" :handle-click="toggle" :active="active">Bundle</app-tabs-trigger> -->
                    <!-- <app-tabs-trigger name="bundled-service" :handle-click="toggle" :active="active">Bundled Service</app-tabs-trigger> -->
                    <!-- <app-tabs-trigger name="linked-service" :handle-click="toggle" :active="active">Linked Service</app-tabs-trigger> -->
                </div>

                <div slot="items" slot-scope="{ active }">
                    <app-tabs-content name="general" :active="active">

                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full md:w-1/2 px-2">
                                <app-field-text
                                    :required="true"
                                    label="Title"
                                    v-model="fields.title"
                                    :error="errors.title"
                                />
                            </div>
                            <div class="w-full md:w-1/2 px-2">
                                <app-field-text
                                    :required="true"
                                    label="Slug"
                                    description="Lowercase letters, numbers and hyphens (-) ONLY. No special letters e.g. Ö, ü, ß"
                                    v-model="fields.slug"
                                    :error="errors.slug"
                                />
                            </div>
                        </div>

                        <app-field-toggle
                            :required="false"
                            label="Published?"
                            v-model="fields.published"
                            :error="errors.published"
                        />

                        <app-field-datetime
                            :required="false"
                            label="Published At"
                            v-if="fields.published"
                            v-model="fields.published_at"
                            :error="errors.published_at"
                        />

                        <app-field-datetime
                            :required="false"
                            label="Expires At"
                            v-if="fields.published"
                            v-model="fields.expires_at"
                            :error="errors.expires_at"
                        />

                        <app-field-text
                            :required="false"
                            label="Position"
                            v-model="fields.position"
                            :error="errors.position"
                        />
                    </app-tabs-content>
                    <app-tabs-content name="content" :active="active">


                        <div class="flex flex-wrap -mx-2 px-2">
                            <app-field-toggle
                                :required="false"
                                label="Display 'Price Copy' only when users vehicle IS NOT selected?"
                                description="<br /><small>If this is not enabled, 'Price Copy' will display at all times.</small>"
                                v-model="fields.from_copy_display"
                                :error="errors.from_copy_display"
                            />
                        </div>

                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full md:w-1/2 px-2">
                                <app-field-text
                                    :required="false"
                                    label="Price Copy"
                                    v-model="fields.from_copy"
                                    :error="errors.from_copy"
                                />
                            </div>
                            <div class="w-full md:w-1/2 px-2">
                                <app-field-currency
                                    :required="true"
                                    label="Price"
                                    v-model="fields.from_price"
                                    :error="errors.from_price"
                                />
                            </div>
                        </div>

                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full md:w-1/2 px-2">
                                <app-field-text
                                    :required="false"
                                    label="Saving Price Copy"
                                    v-model="fields.saving_price_copy"
                                    :error="errors.saving_price_copy"
                                />
                            </div>
                            <div class="w-full md:w-1/2 px-2">
                                <app-field-currency
                                    :required="false"
                                    label="Saving Price"
                                    v-model="fields.saving_price"
                                    :error="errors.saving_price"
                                />
                            </div>
                        </div>

                        <app-field-trix
                            :required="false"
                            label="Description"
                            v-model="fields.description"
                            :error="errors.description"
                        />

                        <app-field-trix
                            :required="false"
                            label="Terms and conditions"
                            v-model="fields.terms"
                            :error="errors.terms"
                        />

                        <app-field-file
                            :required="false"
                            label="Thumbnail"
                            v-model="fields.thumbnail"
                            :error="errors.thumbnail"
                            helper="Maximum width: 750px"
                            :types="{images: true, files: false}"
                        />

                        <app-field-repeatable
                            :required="false"
                            label="Features"
                            placeholder="Feature item"
                            v-model="fields.checklist"
                            :error="errors.checklist"
                        />
                    </app-tabs-content>
                    <app-tabs-content name="locations" :active="active" v-if="!fields.autino_enabled">
                        <div>
                            <app-field-toggle
                                :required="false"
                                label="Display this service on the 'Services' page when no user location is set?"
                                v-model="fields.services_display"
                                :error="errors.services_display"
                            />
                        </div>

                        <div class="mb10" v-for="(l, i) in items.locations" :key="l.ref">
                            <app-table v-if="items.locations.length > 0">
                                <app-table-header>
                                    <app-table-row :header="true">
                                        <app-table-cell class="text-lg text-blue" :header="true">
                                            <strong>{{ l.name }}</strong>
                                        </app-table-cell>
                                        <app-table-cell class="text-center" :header="true">
                                            <strong>Price</strong>
                                        </app-table-cell>
                                        <app-table-cell class="text-center" :header="true">
                                            <strong>Published / Enabled</strong>
                                        </app-table-cell>
                                    </app-table-row>
                                </app-table-header>

                                <app-table-body>
                                    <app-table-row>
                                        <app-table-cell v-html="'Vehicle type'" />
                                        <app-table-cell class="text-center">
                                            <!-- <app-field-currency
                                                :required="true"
                                                v-model="fields.config[l.ref].price"
                                                :error="errors.price"
                                                :classes="{ wrapper: { 'reset': true } }"
                                            /> -->
                                        </app-table-cell>
                                        <app-table-cell class="text-center">
                                            <app-field-toggle
                                                :required="false"
                                                v-model="fields.config[l.ref].published"
                                                :error="errors.published"
                                                :classes="{ wrapper: { 'reset': true } }"
                                            />
                                        </app-table-cell>
                                    </app-table-row>
                                    <app-table-row :vehicle="true" v-for="(v, i) in fields.config[l.ref].menu_pricing" :key="`${l.ref}-${i}`">
                                        <app-table-cell v-html="v.vehicle" />
                                        <app-table-cell class="text-center">
                                            <app-field-currency
                                                :required="true"
                                                v-model="fields.config[l.ref].menu_pricing[i].SalePrice.amount"
                                                :error="errors.price"
                                                :classes="{ wrapper: { 'reset': true } }"
                                            />
                                        </app-table-cell>
                                        <app-table-cell />
                                    </app-table-row>
                                </app-table-body>
                            </app-table>
                        </div>
                    </app-tabs-content>
                    <app-tabs-content name="seo" :active="active">
                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full md:w-1/2 px-2">
                                <app-field-repeatable
                                    :required="false"
                                    label="Keywords (for searching)"
                                    placeholder="Enter a keyword"
                                    v-model="fields.keywords"
                                    :error="errors.keywords"
                                />
                            </div>
                            <div class="w-full md:w-1/2 px-2">
                                <app-field-repeatable
                                    :required="false"
                                    label="Phrases (for searching)"
                                    placeholder="Enter a phrase"
                                    v-model="fields.phrases"
                                    :error="errors.phrases"
                                />
                            </div>
                        </div>

                        <app-field-text
                            :required="false"
                            label="Meta Title"
                            v-model="fields.meta_title"
                            :error="errors.meta_title"
                        />

                        <app-field-textarea
                            :required="false"
                            label="Meta Description"
                            v-model="fields.meta_desc"
                            :error="errors.meta_desc"
                            rows="4"
                        />

                        <app-seo-widget :title="fields.meta_title" :description="fields.meta_desc" :slug="fields.slug" />
                    </app-tabs-content>

                    <app-tabs-content name="bundle" :active="active">
                        <app-field-toggle
                            :required="false"
                            label="Display bundle saving?"
                            description="<br /><small>Please note:* This will overwrite any saving prices made in the content tab.</small>"
                            v-model="fields.display_bundle_saving"
                            :error="errors.display_bundle_saving"
                        />

                        <app-field-select
                            :required="true"
                            label="Included Bundled Services"
                            :items="mappedBundleSelect"
                            v-model="bundle.field"
                            preselect="&mdash; Please select &mdash;"
                        />

                        <app-button element="a" class="btn  btn--primary  btn--primary--full  btn--primary--sml" @click="addToBundle">Add to bundle</app-button>

                        <app-table class="mt-10" v-if="bundle.bundled.length > 0">
                            <app-table-row v-for="(value, index) in mappedBundleServices" :key="index">
                                <app-table-cell>{{ value.name }}</app-table-cell>
                                <app-table-cell>
                                    <app-icon icon="trash" class="text-red cursor-pointer" @click="removeFromBundle(value.id)" />
                                </app-table-cell>
                            </app-table-row>
                        </app-table>
                    </app-tabs-content>

                    <app-tabs-content name="bundled-service" :active="active">
                        <app-field-text
                            label="Title"
                            v-model="fields.bundle_service_title"
                            :error="errors.bundle_service_title"
                        />

                        <app-field-text
                            label="Sub Title (Leave blank to display automatic price saving)"
                            v-model="fields.bundle_service_description"
                            :error="errors.bundle_service_description"
                        />

                        <app-table class="mt-10" v-if="Object.keys(items.bundles).length > 0">
                            <app-table-row v-for="(value, index) in items.bundles" :key="index">
                                <app-table-cell>{{ value.title }}</app-table-cell>
                                <app-table-cell>
                                    <app-button element="span" class="btn  btn--secondary btn--secondary--sml" v-if="fields.bundle_service_id == value.id">Selected</app-button>
                                    <app-button element="a" class="btn  btn--tertiary btn--secondary--sml" @click="selectBundle(value.id)" v-else>Select Bundle</app-button>
                                </app-table-cell>
                            </app-table-row>
                        </app-table>
                    </app-tabs-content>

                    <app-tabs-content name="linked-service" :active="active">
                        <app-field-select
                            :required="true"
                            label="Linked Service"
                            :items="items.linked"
                            v-model="fields.linked_service_id"
                            preselect="&mdash; Please select &mdash;"
                            :error="errors.linked_service_id"
                        />
                    </app-tabs-content>
                </div>
            </app-tabs-wrapper>
        </app-content>
    </app-main>
</template>

<script>
    import { mapGetters } from 'vuex';
    /* API */
    import Api from '@/api/index.js';
    import Auth from '@/api/auth.js';
    /* Components */
    import Main from '@/components/Main';
    import Content from '@/components/template/Content';
    import Title from '@/components/Title';
    import Box from '@/components/Box';
    import Button from '@/components/Button';
    import SelectField from '@/components/fields/inputs/Select';
    import TextField from '@/components/fields/inputs/Text';
    import CategoryField from '@/components/fields/inputs/Category';
    import ToggleField from '@/components/fields/inputs/Toggle';
    import TextareaField from '@/components/fields/inputs/Textarea';
    import DateTimeField from '@/components/fields/inputs/DateTime';
    import TrixField from '@/components/fields/inputs/Trix';
    import CurrencyField from '@/components/fields/inputs/Currency';
    import RepeatableField from '@/components/fields/inputs/Repeatable';
    import FileField from '@/components/fields/inputs/File';
    import TabsWrapper from '@/components/tabs/Wrapper';
    import TabsTrigger from '@/components/tabs/Trigger';
    import TabsContent from '@/components/tabs/Content';
    import SEO from '@/components/SEO';

    /* Mixins */
    import ValidationErrors from '@/mixins/validationErrors.js';

    export default {
        name: 'services.edit',

        data: () => ({
            service: null,
            fields: {
                locale_id: 1,
                category_id: '',
                service_categories: [],
                title: '',
                slug: '',
                description: '',
                benefit: '',
                terms: '',
                from_copy_display: false,
                from_copy: 'Now only',
                from_price: '',
                saving_price_copy: '',
                saving_price: '',
                thumbnail: '',
                image: '',
                checklist: [],
                keywords: [],
                phrases: [],
                meta_title: '',
                meta_desc: '',
                booking_form: true,
                autino_enabled: false,
                published: false,
                published_at: '',
                expires_at: '',
                config: {},
                display_bundle_saving: false,
                bundled: [],
                bundle_service_id: '',
                bundle_service_title: '',
                bundle_service_description: '',
                is_commercial: 0,
                is_camper: 0,
                is_referral: 0,
                services_display: 1,
                display: 1,
                position: '',
                linked_service_id: 0,
            },
            bundle: {
                services: [],
                select: [],
                field: '',
                bundled: []
            },
            items: {
                locales: [],
                categories: [],
                locations: [],
                services: [],
                bundles: [],
                toggles: [
                    {
                        value: 0,
                        label: 'No'
                    },
                    {
                        value: 1,
                        label: 'Yes'
                    }
                ],
                linked: [],
            },
            loading: false,
            errors: {}
        }),

        components: {
            'app-main': Main,
            'app-content': Content,
            'app-title': Title,
            'app-box': Box,
            'app-button': Button,
            'app-field-select': SelectField,
            'app-field-text': TextField,
            'app-field-category': CategoryField,
            'app-field-toggle': ToggleField,
            'app-field-textarea': TextareaField,
            'app-field-datetime': DateTimeField,
            'app-field-trix': TrixField,
            'app-field-currency': CurrencyField,
            'app-field-repeatable': RepeatableField,
            'app-field-file': FileField,
            'app-tabs-wrapper': TabsWrapper,
            'app-tabs-trigger': TabsTrigger,
            'app-tabs-content': TabsContent,
            'app-seo-widget': SEO
        },

        mixins: [
            ValidationErrors
        ],

        mounted() {
            if (typeof this.$route.params.id != 'undefined') {
                this.loading = true;

                this.getVehicleTypes()
                    .then(response => {
                        return this.getCategories()
                            .then(response => {
                                return this.getLocations();
                            })
                            .then(response => {
                                if (typeof this.$route.params.id != 'undefined') {
                                    this.getService(this.$route.params.id)
                                        .then(response => {
                                            this.loading = false;

                                            this.setLocales();

                                            this.setLinkedServiceById();

                                            for (let index in this.service) {
                                                if (typeof this.fields[index] !== 'undefined') {
                                                    switch (index) {
                                                        case "published_at":
                                                            if(this.service[index] != null) {
                                                                this.fields[index] = this.service[index].split(' ').join('T') + '.000Z';
                                                            }
                                                            break;

                                                        case "expires_at":
                                                            if(this.service[index] != null) {
                                                                this.fields[index] = this.service[index].split(' ').join('T') + '.000Z';
                                                            }
                                                            break;

                                                        case "parent_id":
                                                            if(this.service['id'] != null) {
                                                                this.fields[index] = this.service.id;
                                                            }
                                                            break;

                                                        case "config":
                                                            for(let key in this.service[index]) {
                                                                if(typeof this.service[index][key].location_ref != 'undefined' && this.fields[index][this.service[index][key].location_ref] != 'undefined') {
                                                                    this.fields[index][this.service[index][key].location_ref] = {
                                                                        price: this.service[index][key].from_price,
                                                                        published: true
                                                                        // published: this.service[index][key].from_price > 0 ? true : false
                                                                    };

                                                                    if (!this.fields.autino_enabled) {
                                                                        this.fields[index][this.service[index][key].location_ref]['menu_pricing'] = this.service[index][key]['menu_pricing'];
                                                                    }
                                                                }
                                                            }
                                                            break;

                                                        case 'service_categories':
                                                            for(let key in this.service[index]) {
                                                                if(typeof this.service[index][key].category_id !== 'undefined') {
                                                                    this.fields[index].push(this.service[index][key].category_id);
                                                                }
                                                            }
                                                            break;
                                                        default:
                                                            this.fields[index] = this.service[index];
                                                    }
                                                }
                                            }

                                            // this.fields.parent_id = this.$route.params.id;
                                            this.fields.package_ref = this.service.package_ref;
                                        });
                                }
                            })
                            .then(response => {
                                return this.getServices();
                            })
                            .then(response => {
                                this.loading = false;
                            });
                    });
            } else {
                this.$router.push({name: 'services.home'});
            }
        },

        computed: {
            ...mapGetters({
                locales: 'locales/items',
                autino: 'user/autino'
            }),

            mappedCategories() {
                return this.items.categories.length > 0 ? this.items.categories.map((item) => {
                    return {
                        name: item.name,
                        icon: item.svg,
                        value: item.id
                    }
                }) : [];
            },

            mappedBundleSelect() {
                const result = [];
                for(let key in this.bundle.select) {
                    if(this.bundle.bundled.indexOf(this.bundle.select[key].value) === -1) {
                        result.push({
                            label: this.bundle.select[key].label,
                            value: this.bundle.select[key].value
                        });
                    }
                }
                return result;
            },

            mappedBundleServices() {
                const result = [];
                for(let key in this.bundle.bundled) {
                    if(typeof this.bundle.services[this.bundle.bundled[key]] !== 'undefined') {
                        result.push({
                            id: this.bundle.bundled[key],
                            name: this.bundle.services[this.bundle.bundled[key]]
                        });
                    }
                }
                return result;
            }
        },

        methods: {
            checkLocale(locale_check) {
                for (let index in this.locales) {
                    if (this.locales[index].flag == locale_check && this.locales[index].default == 1) {
                        return true;
                    }
                }

                return false;
            },
            getLocations() {
                return Api.request('get', `offers/locations`)
                    .then(({ data }) => {
                        this.items.locations = data.locations;
                        for(let index in data.locations) {
                            this.fields.config[data.locations[index].ref] = {
                                price: 0.00,
                                published: false
                            };

                            for(let key in this.items.vehicle_types) {
                                if (!this.fields.config[data.locations[index].ref].hasOwnProperty('menu_pricing')) {
                                    this.fields.config[data.locations[index].ref]['menu_pricing'] = {};
                                }

                                this.fields.config[data.locations[index].ref]['menu_pricing'][key] = {
                                    vehicle: this.items.vehicle_types[key].type,
                                    VehicleClassificationRef: this.items.vehicle_types[key].ref,
                                    SalePrice: {
                                        amount: 0.00,
                                    }
                                };
                            }
                        }
                    });
            },
            getCategories() {
                return Api.request('get', `services/categories`)
                    .then(({ data }) => {
                        this.items.categories = data.categories;
                    });
            },
            getVehicleTypes() {
                return Api.request('get', `services/vehicle-types`)
                    .then(({ data }) => {
                        this.items.vehicle_types = data.vehicleTypes;
                    });
            },
            getServices() {
                return Api.request('get', `services/all?id=${this.$route.params.id}`).then(({ data }) => {
                    this.bundle.services = data.services;
                    this.bundle.select = data.select;
                });
            },
            getService(id) {
                return Api.request('get', `services/edit/${id}`)
                    .then(({ data }) => {
                        this.service = data.service;
                        this.bundle.bundled = data.bundle;
                        this.items.bundles = data.bundles;
                    });
            },
            addToBundle() {
                event.preventDefault();

                if(this.bundle.field !== '') {
                    this.bundle.bundled.push(parseInt(this.bundle.field));
                }
            },
            removeFromBundle(id) {
                event.preventDefault();

                const index = this.bundle.bundled.indexOf(id);
                if(index !== -1) this.bundle.bundled.splice(index, 1);
            },
            selectBundle(id) {
                event.preventDefault();

                this.fields.bundle_service_id = id;
            },
            save() {
                this.loading = true;
                this.clearErrors();
                this.fields.bundled = this.bundle.bundled;

                return Api.request('post', `services/update/${this.service.id}`, this.fields).then(response => {
                    if(typeof response.data.message != 'undefined') {
                        this.$toasted.show(response.data.message, {
                            type: "success",
                            position: "bottom-right",
                            duration : 5000
                        });
                    }
                    if(typeof response.data.id != 'undefined') {
                        this.$router.push({
                            name: 'services.home',
                            query: {
                                page: this.$route.params.page ? this.$route.params.page : 1,
                                search: this.$route.params.search ? this.$route.params.search : ''
                            }
                        });
                    }
                }).catch(error => {
                    if(this.hasErrors(error)) {
                        this.addErrors(error);
                    }
                }).then(response => {
                    this.loading = false;
                });
            },
            setLocales() {
                if (this.locales.length > 0) {
                    this.locales.forEach(locale => {
                        this.items.locales.push({
                            label: locale.lang,
                            value: locale.id
                        });
                    });
                }
            },

            setLinkedServiceById() {
                return Api.request('get', `services/all`)
                  .then(response => {
                    const data  = response.data.select;
                    if (data.length > 0) {
                        data.forEach(service => {
                            this.items.linked.push({
                                label: service.label,
                                value: service.value
                            });
                        });
                    }
                })
            }
        },

        // watch: {
        //     'fields.title': {
        //         handler(val) {
        //             this.fields.slug = val.toString().toLowerCase()
        //                 .replace(/\s+/g, '-')           // Replace spaces with -
        //                 .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
        //                 .replace(/\-\-+/g, '-')         // Replace multiple - with single -
        //                 .replace(/^-+/, '')             // Trim - from start of text
        //                 .replace(/-+$/, '');            // Trim - from end of text
        //         }
        //     }
        // }
    }
</script>



// WEBPACK FOOTER //
// src/views/services/Edit.vue